'use es6';

import { listOf } from 'react-immutable-proptypes';
import FilterEditorOperatorDescription from './FilterEditorOperatorDescription';
import FilterEditorOperatorDescriptionGroupHeader from './FilterEditorOperatorDescriptionGroupHeader';
import FilterOperatorDescriptionType from '../propTypes/FilterOperatorDescriptionType';
import PropTypes from 'prop-types';
import { memo, Fragment, isValidElement } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterEditorOperatorDescriptionGroup = props => {
  const {
    OperatorDescriptionComponent,
    baseFilterFamily,
    currencyCode,
    descriptions,
    filterFamily,
    getIsUngated,
    getFieldDefinitions,
    getFilterFamilyGroupHeading,
    getLabelString,
    getOperatorLabel,
    getOperators,
    getReferencedObjectType,
    getSpecialOptionsForReferenceType,
    getValueResolver,
    isXoEnabled
  } = props;
  const content = descriptions.reduce((acc, description, index) => {
    const children = /*#__PURE__*/_jsx(FilterEditorOperatorDescription, {
      baseFilterFamily: baseFilterFamily,
      currencyCode: currencyCode,
      getFieldDefinitions: getFieldDefinitions,
      getIsUngated: getIsUngated,
      getLabelString: getLabelString,
      getOperatorLabel: getOperatorLabel,
      getOperators: getOperators,
      getReferencedObjectType: getReferencedObjectType,
      getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
      getValueResolver: getValueResolver,
      index: index,
      isXoEnabled: isXoEnabled,
      value: description
    }, `${description.operator.name}-${index}`);
    const WrapperComponent = OperatorDescriptionComponent({
      children,
      description
    });
    if ( /*#__PURE__*/isValidElement(WrapperComponent)) {
      acc.push(WrapperComponent);
    }
    return acc;
  }, []);
  if (content.length === 0) {
    return null;
  }
  const filterFamilyHeading = getFilterFamilyGroupHeading(filterFamily);
  return filterFamily === baseFilterFamily ? /*#__PURE__*/_jsx(Fragment, {
    children: content
  }) : /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FilterEditorOperatorDescriptionGroupHeader, {
      children: filterFamilyHeading
    }), content]
  }, filterFamily);
};
FilterEditorOperatorDescriptionGroup.propTypes = {
  OperatorDescriptionComponent: PropTypes.func.isRequired,
  baseFilterFamily: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  descriptions: listOf(FilterOperatorDescriptionType).isRequired,
  filterFamily: PropTypes.string.isRequired,
  getFieldDefinitions: PropTypes.func.isRequired,
  getFilterFamilyGroupHeading: PropTypes.func.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  getLabelString: PropTypes.func.isRequired,
  getOperatorLabel: PropTypes.func.isRequired,
  getOperators: PropTypes.func.isRequired,
  getReferencedObjectType: PropTypes.func.isRequired,
  getSpecialOptionsForReferenceType: PropTypes.func.isRequired,
  getValueResolver: PropTypes.func.isRequired,
  isXoEnabled: PropTypes.bool.isRequired
};
export default /*#__PURE__*/memo(FilterEditorOperatorDescriptionGroup);